import { render, staticRenderFns } from "./MessageTable.vue?vue&type=template&id=158fe27d&"
import script from "./MessageTable.vue?vue&type=script&lang=js&"
export * from "./MessageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports